import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const CTA = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yBg = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} id="contact" className="relative py-40 md:py-56 overflow-hidden bg-brand-dark" data-id="element-14">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-15">
        <motion.div style={{
        y: yBg
      }} className="w-full h-[120%] -top-[10%] absolute" data-id="element-16">
          <img src="https://cdn.magicpatterns.com/uploads/izZHwqrQkC9cpfBcRpymy9/IMG_2742-PROOF-THOMAS-MASOTTI.jpg" alt="Traitement de détatouage laser dans le dos chez Dispel Your Tattoo" className="w-full h-full object-cover object-center opacity-25 grayscale" loading="lazy" data-id="element-17" />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/90 to-brand-dark/70" data-id="element-18"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-19">
        <ScrollReveal blur scale duration={1.2} data-id="element-20">
          <h2 className="text-5xl md:text-7xl lg:text-[6.5rem] font-black text-brand-light mb-12 tracking-tighter leading-[1.02] text-balance" data-id="element-21">
            Réservez Votre Consultation de Détatouage à Martigny
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} blur data-id="element-22">
          <p className="text-xl md:text-2xl text-brand-gray font-light mb-20 max-w-3xl mx-auto leading-relaxed" data-id="element-23">
            Je me ferai un plaisir de vous accueillir, d'évaluer votre projet et
            de répondre à toutes vos questions avec professionnalisme et
            transparence. Si vous recherchez un spécialiste exclusivement dédié
            au détatouage laser, Dispel Your Tattoo est votre adresse de
            confiance à Martigny.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} blur data-id="element-24">
          <motion.button whileHover={{
          scale: 1.03,
          boxShadow: '0 0 30px rgba(245,245,240,0.15)'
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="px-12 py-6 bg-brand-light text-brand-dark rounded-full font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300 text-lg md:text-xl" data-id="element-25">
            Réserver une consultation
          </motion.button>
        </ScrollReveal>
      </div>
    </section>;
};